import { isErrorLocationChange } from 'modules/app/utils';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../actionTypes';

const initialState = false;

const isReady = () => true;
const isAwaiting = () => false;

const onErrorTrigger = (state, action) => (isErrorLocationChange(action) ? initialState : state);

export default createReducer(initialState, {
  [actionTypes.FETCH]: isAwaiting,
  [actionTypes.APPLICATION_IS_READY_SUCCESS]: isReady,
  [actionTypes.APPLICATION_IS_READY_FAILURE]: isReady,
  [LOCATION_CHANGE]: onErrorTrigger,
});
